<template>
<div class="certificate">
<div style="min-height: calc(100% - 220px);box-sizing: border-box;">
  <div class="assessTit">
    <div class="commonW" style="padding-top:16px;">
      <div class="left">
        <img src="../assets/wangLG.png" />
      </div>
     <div class="right"><span><img src="../assets/tel.png" /></span>  400-777-5999</div>
    </div>
  </div>
 <div class="commonW">
 
  <!-- 证书信息 -->
  <div class="step02" style="max-width:780px;margin:0 auto;">
    <div class="title">证书信息</div>
    <el-card class="box-card" shadow="never">
      <img src="../assets/certificate.png" alt="" style="width:120px;margin-top: 20px;">
      <div class="securityInfo">
        <div class="info textBreak">项目名称：{{securityInfo.projectId}}&nbsp;{{securityInfo.projectName}}</div>
        <div class="info">电梯有效期授权至：{{securityInfo.elevatorAuthTime=='FFFFFFFF'?'长期有效':securityInfo.elevatorAuthTime}}</div>
        <div class="info">门禁有效期授权至：{{securityInfo.entranceAuthTime=='FFFFFFFF'?'长期有效':securityInfo.entranceAuthTime}}</div>
      </div>
    </el-card>
    <el-form  :model="downForm" ref="downForm" label-position="left">
      <el-form-item label="" prop="type">
        <span class="itemlabel" style="letter-spacing:4px">证书类型：</span>
        <span class="spanBtn xsBtn" @click="changeType(1)" :class="downForm.licenseType==1?'primary':''">正式证书</span>
        <span class="spanBtn xsBtn" @click="changeType(2)" :class="downForm.licenseType==2?'primary':''">工程调试证书</span>
      </el-form-item>
      <div class="question red" v-if="typeRule">证书类型属于必填项</div>
      <div class="question" @click="toQuestions('3')">证书类型区别是什么？</div>
      <el-form-item prop="type" v-if="downForm.licenseType==1">
        <span class="itemlabel">电脑特征码：</span>
        <el-table :data="lists"
                ref="table"
                v-loading="listLoading"
                highlight-current-row 
                style="width:85%;float:right;margin-bottom: 10px;">
                <el-table-column prop="pcInfo" label="电脑特征值" min-width="240" >
                    <template slot-scope="scope">
                        <el-form :model="scope.row" v-if="scope.row.status==1">
                            <el-form-item prop="pcInfo" >
                                <el-input   type="text" v-model="scope.row.pcInfo" @keydown.native="changeValue" auto-complete="off" name="textfield" placeholder="请输入电脑特征值" :maxlength="255"></el-input>
                            </el-form-item>
                        </el-form>
                        <tooltip-hint v-else :sendTooltipInfo="scope.row.pcInfo"></tooltip-hint>
                    </template>
                </el-table-column>
                <el-table-column  label="" min-width="160" >
                    <template slot-scope="scope">
                      <div v-if="scope.row.status==1">
                        <el-upload action="" accept="image/png, image/jpeg, image/jpg" :show-file-list="false" :http-request="resolveQR" style="display:inline-block;">
                          <el-button type="primary" icon="el-icon-upload2" size="medium">上传</el-button>
                        </el-upload>
                        <!-- <el-button @click="onTake" icon="el-icon-camera" type="primary" size="medium"> 拍摄 </el-button> -->
                        <el-button @click="saveCert(scope.$index)" type="primary" size="medium" :loading="saveCertLoading"> <i class="fa fa-floppy-o">&nbsp;&nbsp;保存</i> </el-button>
                      </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="el-table-add-row" @click="addCert"><span>+ 新增</span></div>
          </el-form-item>
          <!-- 拍摄弹框 -->
          <el-dialog title="拍摄" :visible.sync="visible" @close="onCancel" width="1065px">
            <div class="box">
              <video id="videoCamera" class="canvas" :width="videoWidth" :height="videoHeight" autoPlay></video>
              <canvas id="canvasCamera" class="canvas" :width="videoWidth" :height="videoHeight"></canvas>
            </div>
            <div slot="footer">
              <el-button @click="drawImage" icon="el-icon-camera" size="small">拍照</el-button>
              <el-button v-if="open" @click="getCompetence" icon="el-icon-video-camera" size="small"> 打开摄像头</el-button>
              <el-button v-else @click="stopNavigator" icon="el-icon-switch-button" size="small"> 关闭摄像头</el-button>
              <el-button @click="resetCanvas" icon="el-icon-refresh" size="small"> 重置 </el-button>
              <el-button @click="onCancel" icon="el-icon-circle-close" size="small"> 取消 </el-button>
              <el-button @click="onUpload" :loading="loading" type="primary" icon="el-icon-upload2" size="small"> 上传 </el-button>
            </div>
          </el-dialog>
        
      <div class="question red"  v-if="pcInfoRule">{{errTip}}</div>
      <div class="question"  v-if="downForm.licenseType==1" @click="toQuestions('2')">如何查看找到电脑特征码？</div>
      <div style="width:680px;text-align:center;margin-top:80px;">
        <el-button type="primary" style="width:200px;" @click.native.prevent="downLoadLcx" :loading="downLoading">下载
        </el-button>
      </div>
    </el-form>
  </div>

  </div>
  </div>
  <div class="footer clear-fix" style="min-width:1100px;margin-top:20px;">
    <div style="max-width:1100px;margin:0 auto;">
      <div class="aboutUs">
        <div class="title">关于我们</div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/about.html" rel="noopener noreferrer">企业介绍</a></div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/qiyewenhua.html" rel="noopener noreferrer">企业文化</a></div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/zizhirongyu.html" rel="noopener noreferrer">资质荣誉</a></div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/hezuohuoban73.html" rel="noopener noreferrer">合作伙伴</a></div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/pinpaiziyuan.html" rel="noopener noreferrer">品牌资源</a></div>
      </div>
      <div class="footerBor footerBor1"></div>
      <div class="concatUs">
        <div class="title">联系我们</div>
        <div>总　　机　0755-86675999 </div>
        <div>销售邮箱　shangwu@itlong.com.cn</div>
        <div>售后邮箱　fw@itlong.com.cn</div>
        <div>总部地址　深圳市南山区学苑大道1001号南山智园C1栋12楼</div>
        <div>邮　　编　518055   </div>
      </div>
      <div class="footerBor footerBor2"></div>
      <div class="company">
        <div>Copyright © 1997-2020 版权所有:深圳市旺龙智能科技有限公司</div>
        <div>粤ICP备18085992号</div>
        <div>旺龙智能-为您提供智能云梯控，云门禁，云对讲报价、价格、采购，智能云梯控、云门禁、云对讲品牌商，厂家，供应商，批发商！</div>
      </div>
    </div>
  </div>
 </div>
</template>
<script>
import QrCode from 'qrcode-decoder'
  export default {
    data() {
      return {
        securityInfo:{
          projectId:'',
          projectName:'',
          elevatorAuthTime:'',
          entranceAuthTime:''
        },
        lists:[{pcInfo:'',status:1}],
        pcInfoFlag:false,
        index:0,
        listLoading:false,
        saveCertLoading:false,
        downForm:{
          licenseType:'1',
        },
        typeRule:false,
        pcInfoRule:false,
        errTip:'安全证书已超过系统允许最大授权数，该特征码证书获取失败。',
        downLoading:false,
        codedata:'',
        fixFlag:false,
        imgSrc: "",
        visible: false,//弹窗
        loading: false,//上传按钮加载
        open: false,//控制摄像头开关
        thisVideo: null,
        thisContext: null,
        thisCancas: null,
        videoWidth: 500,
        videoHeight: 400,
      };
    },
    methods: {
      //在线查询
      searchSubmit(){
          if(window.sessionStorage.getItem('securityInfo')){
              this.securityInfo=JSON.parse(window.sessionStorage.getItem('securityInfo'))
              this.lists=[];
              if(this.securityInfo.pcInfoList){
                this.securityInfo.pcInfoList.forEach(ele => {
                    this.lists.push({pcInfo:ele,status:0})
                });
              }
              this.lists.push({pcInfo:'',status:1})
              this.index=this.lists.length-1;
              sessionStorage.clear();
          }else{
            if(!this.$route.query.projectId||!this.$route.query.securityCode){
                this.$router.push({path: '/search'})
                return false; 
            }
            this.listLoading=true;
            var params = {
                projectId: window.atob(this.$route.query.projectId),
                securityCode: window.atob(this.$route.query.securityCode),
                operateFunction:'',
                operateWay:'',
            };
            this.$api.getLicense(params).then((res) => {
                this.listLoading=false;
                if (this.$util.checkCode(this, res)) {
                this.securityInfo=res.data;
                this.lists=[];
                if(this.securityInfo.pcInfoList){
                    this.securityInfo.pcInfoList.forEach(ele => {
                        this.lists.push({pcInfo:ele,status:0})
                    });
                }
                this.lists.push({pcInfo:'',status:1})
                this.index=this.lists.length-1;
                }
            }).catch((err) => {
                this.listLoading=false;
                this.$util.showCatchErr(this, err, "获取证书信息失败");
            });
          }
      },
      resetValidCode() {
        this.searching = false;
        this.getValidCode();
      },
      //保存安全码
      saveCert(index){
        if(this.lists[index].pcInfo!=''){
            var reg = new RegExp("^[0-9A-Za-z]{1,255}$", "ig");
            if(!reg.test(this.lists[index].pcInfo)){
                this.$message({
                message: "电脑特征码只支持字母和数字",
                type: 'error'
            });
            return false;
            }
          this.saveCertLoading=true;
          var params = {
            pcInfo:this.lists[index].pcInfo,
            projectId:this.securityInfo.projectId,
            source: '1',
            operateFunction:'证书网站',
            operateWay:'添加',
          };
          this.$api.savePCInfo(params).then((res) => {
            this.saveCertLoading=false;
            if (this.$util.checkCode(this, res)) {
              this.pcInfoRule=false
              if (res.msgCode == 0) {
                this.$set(this.lists[index],'status',0)
              }else if (res.msgCode == 2530) {
                this.pcInfoRule=true
              }
              
            }
          }).catch((err) => {
            this.saveCertLoading=false;
            this.$util.showCatchErr(this, err, "保存电脑特征值失败");
          });
        }else{
          this.$message.error('请输入电脑特征值')
        }
      },
      //新增安全码
      addCert(){
        if(this.lists[this.index].status==1){
          this.$message.error('请先保存当前证书')
          return;
        }
        this.lists.push({pcInfo:'',status:1})
        this.index++
      },
      changeType(val){
        this.typeRule=false;
        this.downForm.licenseType=val;
        if(val==2){
             this.pcInfoRule=false;
        }
      },
      changeValue(evt){//仅支持粘贴
        // if ((evt.ctrlKey && evt.keyCode == 86)||evt.keyCode == 8 || evt.keyCode == 46) {  // ctrl + v  backspace delete
        // }else{
        //   evt.returnValue=false;
        // }
      },
      downLoadLcx(){
        if(this.downForm.licenseType==''){
          this.typeRule=true;
          return;
        }
        console.log(this.lists)
        if(this.downForm.licenseType==1&&(this.lists.length==0||this.lists[0].pcInfo==''||this.lists[0].status==1)){
            this.$message.error('请添加电脑特征值')
            return;
        }
        let timestamp = Date.parse(new Date());
        let typeName=this.downForm.licenseType==1?('formal_'+this.securityInfo.projectId+'_'+timestamp+'.lcx'):('trial_'+this.securityInfo.projectId+'_'+timestamp+'.lcx');
        this.downLoading=true;
        var params = {
            licenseType:this.downForm.licenseType,
            projectId:this.securityInfo.projectId,
            operateFunction:'证书网站',
            operateWay:'下载证书',
        };
        this.$api.licenseDownload(params).then((res) => {
            this.downLoading=false;
            if (this.$util.checkCode(this, res)) {
              this.download(typeName,res.data.certificateInfo)
            }
          }).catch((err) => {
            this.downLoading=false;
            this.$util.showCatchErr(this, err, "下载证书失败");
          });
        },
      download(fileName, text) {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = new Blob([text], {type:  "text/lcx;charset=utf-8"});
            window.navigator.msSaveOrOpenBlob(blob, fileName);
        }else{
          var element = document.createElement('a');
          element.setAttribute('href', 'data:text/lcx;charset=utf-8,' + encodeURIComponent(text));
          element.setAttribute('download', fileName);
        
          element.style.display = 'none';
          document.body.appendChild(element);
        
          element.click();
        
          document.body.removeChild(element);
        }
      },
      toQuestions(val){
        window.open('/question?activeName='+window.btoa(val), "_blank");
      },
      //base64转成文件后上传
      onUpload() {
          console.log(this.imgSrc)
          if (this.imgSrc) {
          const conversions =this.blobToFile(this.base64ToBlob(this.imgSrc), 'test.jpg'); // 调用base64转图片方法
          console.log(conversions)
          const result = this.getQrUrl(conversions)
          result.then(res => {
              if (res.data) {
              alert(res.data)
              this.$message.success('识别二维码成功!')
              } else {
              this.$message.error('识别二维码失败, 请重新上传')
              }
          }).catch(err => {
              this.$message.error(JSON.stringify(err))
          })
          }else {
          this.$notify({
              title: '警告',
              message: '请点击拍照',
              type: 'warning'
          });
          }
      },
      onTake() {
        this.visible = true;
        this.getCompetence();
      },
      onCancel() {
          this.visible = false;
          this.resetCanvas();
          this.stopNavigator();
      },
      // 调用摄像头权限
      getCompetence() {
          //必须在model中render后才可获取到dom节点,直接获取无法获取到model中的dom节点
          this.$nextTick(() => {
          const _this = this;
          this.open = false;//切换成关闭摄像头
          this.thisCancas = document.getElementById('canvasCamera');
          this.thisContext = this.thisCancas.getContext('2d');
          this.thisVideo = document.getElementById('videoCamera');
          // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
          if (navigator.mediaDevices === undefined) {
              navigator.mediaDevices = {}
          }
          // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
          // 使用getUserMedia，因为它会覆盖现有的属性。
          // 这里，如果缺少getUserMedia属性，就添加它。
          
          if (navigator.mediaDevices.getUserMedia === undefined) {
              navigator.mediaDevices.getUserMedia = function (constraints) {
              // 首先获取现存的getUserMedia(如果存在)
              console.log(navigator.webkitGetUserMedia,navigator.mozGetUserMedia,navigator.getUserMedia,navigator.getMedia)
              let getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia||navigator.getMedia;
              // 有些浏览器不支持，会返回错误信息
              // 保持接口一致
              console.log(getUserMedia)
              if (!getUserMedia) {
                  return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
              }
              // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
              return new Promise(function (resolve, reject) {
                  getUserMedia.call(navigator, constraints, resolve, reject)
              })
              }
          }
          const constraints = {
              audio: false,
              video: {width: _this.videoWidth, height: _this.videoHeight, transform: 'scaleX(-1)'}
          };
          navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
            
              // 旧的浏览器可能没有srcObject
              if ('srcObject' in _this.thisVideo) {
              _this.thisVideo.srcObject = stream
              } else {
              // 避免在新的浏览器中使用它，因为它正在被弃用。
              _this.thisVideo.src = window.URL.createObjectURL(stream)
              }
              _this.thisVideo.onloadedmetadata = function (e) {
              _this.thisVideo.play()
              }
          }).catch(err => {
              console.log(err)
              this.visible = false;
              this.$notify({
              title: '警告',
              message: '没有开启摄像头权限或浏览器版本不兼容,请使用其他方式',
              type: 'warning'
              });
          });
          });
      },
      //绘制图片
      drawImage() {
          // 点击，canvas画图
          this.thisContext.drawImage(this.thisVideo, 0, 0, this.videoWidth, this.videoHeight);
          // 获取图片base64链接
          this.imgSrc = this.thisCancas.toDataURL('image/png');
      },
      //base64转blob
      base64ToBlob(code) {
          let parts = code.split(';base64,');
          let contentType = parts[0].split(':')[1];
          let raw = window.atob(parts[1]);
          let rawLength = raw.length;
          let uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
          }
          return new Blob([uInt8Array], {type: contentType});
      },
      //blob转文件
      blobToFile(theBlob, filename){
          theBlob.lastModifiedDate =new Date();
          theBlob.name = filename;
          return theBlob;
      },
      //清空画布
      clearCanvas(id) {
          let c = document.getElementById(id);
          let cxt = c.getContext("2d");
          cxt.clearRect(0, 0, c.width, c.height);
      },
      //重置画布
      resetCanvas() {
          this.imgSrc = "";
          this.clearCanvas('canvasCamera');
      },
      //关闭摄像头
      stopNavigator() {
          if (this.thisVideo && this.thisVideo !== null) {
          this.thisVideo.srcObject.getTracks()[0].stop();
          this.open = true;//切换成打开摄像头
          }
      },
      getQrUrl(file) {
          // 获取临时路径
          const url = window.URL.createObjectURL(file)
          console.log(url)
          // 初始化
          const qr = new QrCode()
          // 解析二维码，返回promise
          return qr.decodeFromImage(url)
      },
      resolveQR(event) {
        console.log(event)
          // if(event.file.name.indexOf('.lcx')>-1){
          //   this.read(event.file)
          //   return;
          // }
          if(event.file.type=='image/jpeg'||event.file.type=='image/png'||event.file.type=='image/jpg'){
            const result = this.getQrUrl(event.file)
            result.then(res => {
                if (res.data) {
                console.log(res.data)
                this.lists[this.index].pcInfo=res.data;
                this.$message.success('识别二维码成功!')
                this.lists.push();
                } else {
                this.$message.error('识别二维码失败, 请重新上传!')
                }
            }).catch(err => {
                this.$message.error(JSON.stringify(err))
            })
          }else{
            this.$message.error('上传二维码图片仅支持PNG、JPG、JPEG格式!')
          }
      },
      read(file) {
        let _this=this;
        let reader = new FileReader();   //先new 一个读文件的对象 FileReader
        reader.readAsArrayBuffer(file); //读任意文件
        reader.onload = function (e) {
          var ints = new Uint8Array(e.target.result); //要使用读取的内容，所以将读取内容转化成Uint8Array
          ints = ints.slice(0, 255); //截取一段读取的内容
          let snippets = new TextDecoder('gb2312').decode(ints); //二进制缓存区内容转化成中文（即也就是读取到的内容）
          _this.lists[_this.index].pcInfo=snippets;
          _this.$message.success('识别特征码文件成功!')
          _this.lists.push();
          console.log("读取的内容如下：");
          console.log(snippets);
	      };
      },
    },
    mounted(){
        this.searchSubmit()
    },
    beforeDestroy() {
        //this.stopNavigator()
    },
  }
</script>
<style scoped>
  .certificate{
    height:100%;
    background:#fff;
    overflow:hidden; 
    overflow-y:auto;
    min-width:1100px;
    max-width:100%;
  }
  .commonW{
    min-width:1100px;
    max-width:1100px;
    margin:0 auto;
  }
  .el-table-add-row {
    width:85%;float:right;
    height: 34px;
    border: 1px dashed #c1c1cd;
    border-radius: 3px;
    cursor: pointer;
    justify-content: center;
    display: flex;
    line-height: 34px;
  }
  /* 弹框样式 */
  .myToast {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    width: 100%;
    height: 100%;
    display: flex;    
    display: -webkit-flex; /* Safari */
    -webkit-align-items: center; /* Safari 7.0+ */
    align-items: center;
    justify-content: center;
    -webkit-justify-content: center; /* Safari 6.1+ */
  }
  .myToast .error{
    max-width: 300px;
    min-width: 100px;
    background: rgba(0, 0, 0, 0.8);
    padding: 8px 15px;
    text-align: center;
    color: white;
    font-size: 16px;
    border-radius: 5px;
  }
  .assessTit{
    width:100%;
    height:80px;
    margin-bottom:50px;
    background:rgba(255,255,255,1);
    border-bottom:1px solid rgba(190,190,190,1);
  }
  .assessTit img{
    width:250px;
    margin-top:8px;
  }
  .assessTit .left{
    float: left;
  }
  .assessTit .left span{
    display:inline-block;width:1px; height:26px;background:rgba(197,197,197,1);margin:0 10px;
  }
  .assessTit .font{
    font-size: 26px;
    color: #2E2E2E;
    letter-spacing:8px;
    margin-top:8px;
  }
  .assessTit .right{
    float: right;
    font-size: 20px;
    color:#2E2E2E;
  }
  .assessTit .right span{
    display: inline-block;
    width:40px;
    height:40px;
    background:rgba(255,255,255,1);
    border:1px solid #BEBEBE;
    border-radius:50%;
    text-align: center;
  }
  .assessTit .right img{
    width:16px;
    margin-top:12px;
  }
  .step01{
    max-width:680px;
    margin:0 auto;
  }
  .step02{
    margin-top:20px;
  }
  .step02 .tips{
    padding-left:45px;
  }
  .step01  .title,.step02  .title{
    width:100%;
    text-align: center;
    font-size: 28px;
    margin-bottom:40px;
  }
  .step01 .question,.step02 .question{
    margin-bottom: 20px;
    cursor: pointer;
  }
  .step02 .question{
    margin-left: 113px;
  }
  .step02 .box-card{
    padding:30px;
    margin-bottom: 30px;
  }
  .tipBox{
    display: inline-block;
    width:200px;
    height:50px;
    line-height:50px;
    text-align:center;
    border-radius:30px;
    border:1px dashed #1518b8;
    background: #fff;
    position: relative;
    top: -73px;
    left: 567px;
  }
  .tipBox div{
    width:180px;
    border-bottom:1px dashed #1518b8;
    position: absolute;
    left:-180px;
    top:25px;
  }
  .securityInfo{
    display:inline-block;
    vertical-align: top;
    margin-left:50px;
    width:500px;
  }
  .box-card .info{
    height: auto;
    margin-bottom:22px;
  }
  .textBreak{
        text-align:justify;
        word-break:break-all;
        overflow: hidden;
  }
  .gree{color:#67C23A;}
  .red{color: #de0f0f;}
  
  .footer{
    min-width:1100px;
    max-width:100%;
    height:200px;
    background: #31373A;
    z-index: 99999;
    margin-top:20px;
    padding-top:30px;
    box-sizing: border-box;
    color: #C0C0C0;
  }
  .footer .aboutUs,.footer .concatUs,.footer .company{
    float: left;
  }
  .footer .aboutUs div,.footer .concatUs div,.footer .company div{
    margin-bottom:5px;
  }
  .footer .title{
    color:#fff;margin-bottom:15px!important;
  }
  .footer .aboutUs{
    width: 60px;
  }
  .footer .concatUs{
    width: 380px;
  }
  .footer .company{
    width: calc(100% - 600px);
    margin-top:30px;
  }
  .footer .footerBor{
    float: left;
    width: 1px;
    height: 130px;
    background: #616161;
    margin:0 39px;
    margin-top:20px;
  }
  /*清除浮动*/
.clear-fix::after {
  content: ".";    
  display: block;  
  clear: both;     
  visibility: hidden;      
  height: 0;   
  font-size:0;    
}
.spanBtn{
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #FFF;
    border: 1px solid #DCDFE6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
}
.spanBtn.primary{
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
}
.el-collapse{
  border:none;
}
.itemlabel{
  display: inline-block;
  color:#333;
  font-size: 18px;
}
</style>
<style>
 
  a{
    text-decoration:none;
  }
  .step01 .el-input__inner{
    border: none;
    border-bottom: 1px solid #DCDFE6;
    border-radius: 0;
  }
  .step02 .el-table th{
    padding: 4px 0;
  }
  .stepQues .el-collapse-item__header,.stepQues .el-collapse-item__wrap{
    border: none;
  }
  .stepQues .el-collapse-item__header{
    font-size: 16px;
  }
  .stepQues .el-collapse-item__content{
    background: #f3f3f3;
    padding:20px 15px;
    padding-bottom:40px;
    color: #606266;
  }
  html,body{
    height: auto;
  }
   .el-table__header{
        width: 100% !important;
    }
    .el-table__body{
        width: 100% !important;
    }
</style>


// WEBPACK FOOTER //
// Certificate.vue?4134e720